import { motion } from 'framer-motion';

import { styled } from '@/style';

// eslint-disable-next-line import/prefer-default-export
export const ErrorContainer = styled(motion.div)`
  align-self: flex-end;
  color: brand-negative;
`;
